function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var defaults = {
  loadPath: '/locales/{{lng}}/{{ns}}.json',
  addPath: '/locales/add/{{lng}}/{{ns}}',
  multiSeparator: '+',
  allowMultiLoading: false,
  parse: JSON.parse,
  stringify: JSON.stringify,
  fetch: fetch,
  requestOptions: {}
};

var arrify = function arrify(val) {
  return Array.isArray(val) ? val : [val];
};

var normalize = function normalize(funcOrVal) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return typeof funcOrVal === 'function' ? funcOrVal.apply(void 0, args) : funcOrVal;
};

var Backend =
/*#__PURE__*/
function () {
  function Backend(services, options) {
    _classCallCheck(this, Backend);

    _defineProperty(this, "type", 'backend');

    this.init(services, options);
  }

  _createClass(Backend, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.services = services;
      this.options = _objectSpread({}, defaults, this.options, options);
    }
  }, {
    key: "getLoadPath",
    value: function getLoadPath(languages, namespaces) {
      return normalize(this.options.loadPath, languages, namespaces);
    }
  }, {
    key: "read",
    value: function read(language, namespace, callback) {
      var loadPath = this.getLoadPath(language, namespace);
      var url = this.services.interpolator.interpolate(loadPath, {
        lng: language,
        ns: namespace
      });
      this.loadUrl(url, callback);
    }
  }, {
    key: "readMulti",
    value: function readMulti(languages, namespaces, callback) {
      var loadPath = this.getLoadPath(languages, namespaces);
      var multiSeparator = this.options.multiSeparator;
      var url = this.services.interpolator.interpolate(loadPath, {
        lng: languages.join(multiSeparator),
        ns: namespaces.join(multiSeparator)
      });
      this.loadUrl(url, callback);
    }
  }, {
    key: "loadUrl",
    value: function loadUrl(url, callback) {
      var _this$options = this.options,
          fetch = _this$options.fetch,
          requestOptions = _this$options.requestOptions,
          parse = _this$options.parse;
      fetch(url, requestOptions).then(function (response) {
        var ok = response.ok,
            status = response.status;

        if (!ok) {
          var retry = false; // status codes 4xx

          if (status >= 500 && status < 600) retry = true;
          return callback("failed loading ".concat(url), retry);
        }

        return response.text();
      }).then(function (data) {
        try {
          return callback(null, parse(data, url));
        } catch (e) {
          return callback("failed parsing ".concat(url, " to json"), false);
        }
      });
    }
  }, {
    key: "create",
    value: function create(languages, namespace, key, fallbackValue) {
      var _this = this;

      var payload = _defineProperty({}, key, fallbackValue || '');

      arrify(languages).forEach(function (lng) {
        var _this$options2 = _this.options,
            addPath = _this$options2.addPath,
            requestOptions = _this$options2.requestOptions,
            fetch = _this$options2.fetch,
            stringify = _this$options2.stringify;

        var url = _this.services.interpolator.interpolate(addPath, {
          lng: lng,
          ns: namespace
        });

        try {
          fetch(url, _objectSpread({
            method: 'POST',
            body: stringify(payload)
          }, requestOptions));
        } catch (ex) {
          console.error(ex);
        }
      });
    }
  }]);

  return Backend;
}();

_defineProperty(Backend, "type", 'backend');

export default Backend;
